module.exports = __webpack_public_path__ + "media/images/lb/585-845292958441273e90872f9105771fda.svg";